import { NavLink, useLocation } from 'react-router-dom';
// utils
import clsx from 'clsx';
// mantine
import { Tooltip } from '@mantine/core';
// utils
import { TOOLTIP_PORTAL } from '@/const';
// assets
import styles from '@/components/Layout/components/Navbar/components/NavLinkItem/NavLinkItem.module.css';

interface NavLinkItemProps {
    className?: string;
    isExternal?: boolean;
    label: string;
    path?: string;
    icon: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const NavLinkItem = ({
    className,
    isExternal,
    label,
    path = '#',
    icon,
    onClick
}: NavLinkItemProps) => {
    const { pathname } = useLocation();
    const isActive = pathname === path;
    if (isExternal) {
        return (
            <Tooltip
                withinPortal
                arrowPosition="side"
                key={label}
                label={label}
                offset={10}
                portalProps={{ target: `#${TOOLTIP_PORTAL}` }}
                position="right"
            >
                <a
                    className={clsx(
                        styles.link,
                        className,
                        isActive && styles.isActive
                    )}
                    href={path}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {icon}
                </a>
            </Tooltip>
        );
    }
    return (
        <Tooltip
            withinPortal
            arrowPosition="side"
            key={label}
            label={label}
            offset={10}
            portalProps={{ target: `#${TOOLTIP_PORTAL}` }}
            position="right"
        >
            <NavLink
                className={clsx(
                    styles.link,
                    className,
                    isActive && styles.isActive
                )}
                to={path}
                onClick={onClick}
            >
                {icon}
            </NavLink>
        </Tooltip>
    );
};

export default NavLinkItem;
